/*
 * @Author: Roman
 * @Date: 2022-11-03 09:57:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-30 16:14:03
 * @FilePath: \qpmn-site\src\app\modules\basic\header\header-object-tree.service.ts
 * @Description: 
 */

import { IStorageService } from "@core/storage";
import { IProductCatalog } from "@modules/catalog/product-catalog/model/domain/ProductCatalog";
import { PageCacheKey } from "../../basic/page";
import { PageObjectTreeService } from "../../basic/page/page-object-tree.service";
import { IHeaderObjectTreeService } from "./header-object-tree";

export class HeaderObjectTreeService extends PageObjectTreeService implements IHeaderObjectTreeService {

    public static readonly $inject: Array<string> = ["storageService"];

    constructor(public storageService: IStorageService<PageCacheKey>) {
        super();
    }

    getFirstName(): string {
        return this.getCache("firstName") || "";
    }

    getCartQty(): string {
        return this.getCache("CartNumber") || "0";
    }

    clearLogin(): void {
        this.removeCache("Token");
        this.removeCache("TokenType");
        this.removeCache("expire");
        this.removeCache("UserName");
        this.removeCache("firstName");
        this.removeCache("CartNumber");
        this.removeCache("IsAnonymous");
        this.removeCache("PartnerType");
        this.removeCache('StoreList');
        this.removeCache('StoreListExpire');

    }
    /**
     * @description
     * @deprecated
     * TODO 临时做法,集成permissionService后去除
     */
    setAnonymous(isAnonymous: boolean, anonymousUserId?: string) {
        this.setCache("IsAnonymous", isAnonymous.toString());

        if (anonymousUserId) {
            this.setCache("AnonymousUserId", anonymousUserId);
        }
    }
}